import { createFileRoute, Navigate } from "@tanstack/react-router";
import { WorkflowsOverviewPage } from "@/pages/workflows-overview/ui/workflows-overview-page";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";
import { searchParams } from "@/pages/workflows-overview/model/search-params";

const WorkflowsOverviewRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();

  // Redirect non-admin users
  if (!isOwnerOrAdmin) {
    return <Navigate to="/" replace />;
  }

  return <WorkflowsOverviewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/workflows/",
)({
  component: WorkflowsOverviewRoute,
  validateSearch: searchParams,
});
